import { Col, Modal, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import MoneyIcon from 'src/assets/icons/money.png';
import TruckIcon from 'src/assets/icons/truck.png';
import { OpenRelatedTicketType } from 'src/components/v2/Button/BtnHrHandle';
import CustomCard from 'src/components/v2/Card';
import urlPath from 'src/constants/urlPath';
import { ILinkId } from 'src/constants/linkId.enum';
import { CartIcon } from 'src/assets/icons';

interface Props {
  open: OpenRelatedTicketType;
  setOpen: React.Dispatch<React.SetStateAction<OpenRelatedTicketType>>;
}

export default function AddRelatedTicket({ open, setOpen }: Props) {
  const navigate = useNavigate();

  const handleCancel = () => {
    setOpen((prev) => ({
      ...prev,
      businessTripTicketId: '',
      equipmentSupplyTicketId: '',
      isOpen: false
    }));
  };

  return (
    <Modal
      title='Chọn phiếu liên quan'
      open={open.isOpen}
      width={600}
      maskClosable={false}
      onCancel={handleCancel}
      centered
      footer={null}
      styles={{ body: { marginTop: 20 } }}
    >
      {open.businessTripTicketId && (
        <Row justify='space-evenly' className='card-row' gutter={[20, 20]}>
          <Col span={24}>
            <CustomCard
              image={MoneyIcon}
              imageSize={64}
              title='Ứng tiền'
              description='Lập phiếu tạm ứng'
              layout='horizontal'
              action={null}
              size='medium'
              style={{ width: '100%' }}
              hoverable
              onClick={() =>
                navigate(
                  `${urlPath.advancePaymentTicketAdd.location}?${ILinkId.businessTripTicketId}=${open.businessTripTicketId}`
                )
              }
            />
          </Col>
          <Col span={24}>
            <CustomCard
              image={TruckIcon}
              imageSize={64}
              title='Vận chuyển'
              description='Lập phiếu vận chuyển'
              layout='horizontal'
              action={null}
              size='medium'
              style={{ width: '100%' }}
              hoverable
              onClick={() =>
                navigate(
                  `${urlPath.transportationTicketAdd.location}?${ILinkId.businessTripTicketId}=${open.businessTripTicketId}`
                )
              }
            />
          </Col>
        </Row>
      )}
      {open.equipmentSupplyTicketId && (
        <Row justify='space-evenly' className='card-row' gutter={[20, 20]}>
          <Col span={24}>
            <CustomCard
              image={CartIcon}
              imageSize={64}
              title='Yêu cầu mua hàng'
              description='Lập phiếu yêu cầu mua hàng'
              layout='horizontal'
              action={null}
              size='medium'
              style={{ width: '100%' }}
              hoverable
              onClick={() => {
                navigate(
                  `${urlPath.purchaseRequestTicketAdd.location}?${ILinkId.equipmentSupplyTicketId}=${open.equipmentSupplyTicketId}`
                );
              }}
            />
          </Col>
        </Row>
      )}
    </Modal>
  );
}
